
  <mat-form-field
    oneSearchField
    oneSearchFieldBorder="rounded"
    oneSearchFieldAppearance="outline"
    oneSearchFieldSize="slim"
    class="rcp-list-search"
  >
    <mat-icon matPrefix>search</mat-icon>
    <input matInput placeholder="Search" [formControl]="searchbox" (keyup)="applyFilter($event.target.value)"/>
    <button *ngIf="searchbox.value" one-icon-button-flat mat-flat-button matSuffix (click)="searchbox.setValue(''); applyFilter('')">
      <mat-icon>clear</mat-icon>
    </button>
  </mat-form-field>


